import { createContext, useState, useEffect } from "react";

const UserContext = createContext();

const LOCAL_START = "userStartTime";

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [token, setToken] = useState(null);
	const [userPermissions, setUserPermissions] = useState([]);
	const [loadingUserPermissions, setLoadingUserPermissions] = useState(false);
	const [startTime, setStartTime] = useState(() => {
		const saved = localStorage.getItem(LOCAL_START);
		return saved ? new Date(saved) : false;
	});

	const api = process.env.REACT_APP_API_URL;

	useEffect(() => {
		if (!user || !user["https://claim.krummycapture/claim"]) {
			return;
		}
		if (!token) {
			return;
		}
		let userData = user["https://claim.krummycapture/claim"];
		setLoadingUserPermissions(true);
		let userId = userData.odoo_id;
		if (userId) {
			fetch(api + "/permissions", {
				method: "GET",
				headers: {
					Accept: "application/json",
					Authorization: "Bearer " + token,
				},
			})
				.then((res) => {
					if (res.ok) {
						return res.json();
					}
				})
				.then((data) => {
					if (data) {
						if (data.permissions) {
							setUserPermissions(data.permissions);
						}
					}
				})
				.finally(() => {
					setLoadingUserPermissions(false);
				});
		}
	}, [api, token, user]);

	useEffect(() => {
		if (startTime) {
			localStorage.setItem(LOCAL_START, startTime.toISOString());
		} else {
			localStorage.removeItem(LOCAL_START);
		}
	}, [startTime]);

	const userValues = { startTime, setStartTime, user, setUser, token, setToken, api, userPermissions, loadingUserPermissions };

	return <UserContext.Provider value={userValues}>{children}</UserContext.Provider>;
};

export default UserContext;
